import React from "react";
import {VFlex} from "components/_defaultComponents/Flex/VFlex";
import {
    CompanyFilter,
    SubCompanyFilter,
    DateRangeFilter,
    SearchText
} from "components/_defaultComponents/FilterComponents";
import {ZoneSelect} from "components/_defaultComponents/ZoneSelect";
import {FiltersRow, FilterColumn} from "components/credits/styles/CreditLog.styles";
import {NetsisInvoiceStatusFilter} from "./NetsisInvoiceStatusFilter";

const FilterField = ({label, children, ...columnProps}) => (
    <FilterColumn {...columnProps}>
        <VFlex vertical gap={4}>
            <div style={{minHeight: 22}}>
                <h5>{label}</h5>
            </div>
            {children}
        </VFlex>
    </FilterColumn>
);

export const SubCompanyInvoiceFilters = ({filters, onChange}) => {
    const {
        dateRange,
        zoneId,
        companyId,
        subCompanyId,
        invoiceStatus,
        commercialTitle,
        projectCode
    } = filters;
    const hasCompany = !!companyId && companyId !== "all";

    return (
        <FiltersRow>
            <FilterField label="Fatura Kesme Tarihi" $minWidth={240} $flex="1.3 1 0">
                <DateRangeFilter
                    value={dateRange}
                    onChange={value => onChange("dateRange", value)}
                    showLabel={false}
                    allowClear={false}
                    maxRangeDays={60}
                />
            </FilterField>
            <FilterField label="Bölge" $minWidth={160}>
                <ZoneSelect
                    value={zoneId}
                    onChange={value => onChange("zoneId", value)}
                    showTitle={false}
                    showAllOption
                    marginBottom="0"
                />
            </FilterField>
            <FilterField label="Firma" $minWidth={160}>
                <CompanyFilter
                    value={companyId}
                    onChange={value => onChange("companyId", value)}
                    showAllOption={true}
                    allKey="all"
                    disabled={false}
                    hideTitle
                />
            </FilterField>
            <FilterField label="Alt Firma" $minWidth={160}>
                <SubCompanyFilter
                    value={subCompanyId}
                    onChange={value => onChange("subCompanyId", value)}
                    company={hasCompany ? companyId : undefined}
                    initialCall={hasCompany}
                    disabled={!hasCompany}
                    showAllOption={true}
                    allowClear
                    hideTitle
                />
            </FilterField>
            <FilterField label="Ticari Ünvan" $minWidth={160}>
                <SearchText
                    value={commercialTitle}
                    onChange={value => onChange("commercialTitle", value)}
                    showLabel={false}
                />
            </FilterField>
            <FilterField label="Proje Kodu" $minWidth={160}>
                <SearchText
                    value={projectCode}
                    onChange={value => onChange("projectCode", value)}
                    showLabel={false}
                />
            </FilterField>
            <FilterField label="Fatura Durumu" $minWidth={160}>
                <NetsisInvoiceStatusFilter
                    value={invoiceStatus}
                    onChange={value => onChange("invoiceStatus", value)}
                />
            </FilterField>
        </FiltersRow>
    );
};
